module.exports = __webpack_public_path__ + "media/win_sound.afb9W.8777829b.wav";